import type { FaireProductEntity } from "../../entity_types/product";

export const p_3maghfvneu: FaireProductEntity = {
  token: "p_3maghfvneu",
  type: "product",
  name: "Tailored Taffeta Short Sleeve Blouse",
  brandToken: "b_m1k27vexwy",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5758fac4682a87841fd499065a32bda67ed7c182628593cfd9afabaaadc7cacc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15d40f67af9d4452b2596d77ccf571051f093fb0050f958bd65a8801003b4832.jpeg",
    "https://cdn.faire.com/fastly/1a6bda54d9b74ba72cab32675b5836e6c48e5941538ab331d5afa912fe7e2e67.jpeg",
    "https://cdn.faire.com/fastly/fe982ee43d54ae99daaaf6cd18aa10831d2a10cae367c89a0ae04ee0cd78402d.jpeg",
    "https://cdn.faire.com/fastly/f9eee75a601a05af1069a9a83ccfc72a3cade47f323927963b6fbd2d17d4096c.jpeg",
    "https://cdn.faire.com/fastly/a19e94b7001bb46844a87ad0aec446edc264c12f183a733c734260b78947d661.jpeg",
    "https://cdn.faire.com/fastly/7f614fd0fd8b019c0751980c544ff94b6afcecbacb5e1e936e2e08d2d91b3b0a.jpeg",
    "https://cdn.faire.com/fastly/b8fdb2e71c5eef6b61769e9112b9c4f3b05ffdf5b77652a8c4334d7fa90f52a0.jpeg",
    "https://cdn.faire.com/fastly/86e757ecdb4c539ddc0df977336726f4e60c7f4ebd7d822313b25cd18a20a1d4.jpeg",
    "https://cdn.faire.com/fastly/514df0038aeebf1693b678867effb611d029efc768ad94f72ed20d7756e3ff3d.jpeg",
    "https://cdn.faire.com/fastly/45d4ef15f55545f638a51007ab2112aa4ca39ee3d15ebd2e6b326f56319d5652.jpeg",
    "https://cdn.faire.com/fastly/0e5ce967cb24ec97548efdbc974c51d666e5184fe280cd96e491925e4c9e0358.jpeg",
    "https://cdn.faire.com/fastly/9c96a644d7820fcc79cc776091a21c303be7c53fd8ae51af3dcff2007311fa79.jpeg",
    "https://cdn.faire.com/fastly/b0b82b59e43c610d89027edfde37a84b0e39e2f5bfe8ac473df26fe1c009f81c.jpeg",
    "https://cdn.faire.com/fastly/6442b41073702c8eaa91404a5038a8142bb1a8a3bc183e5fa7aba9b518b31855.jpeg",
    "https://cdn.faire.com/fastly/31085a2fb1fc59a284a4563356b023c4fbdf1edc7c1e1549a537415679f0fdaa.jpeg",
    "https://cdn.faire.com/fastly/1f54eea688c85c201c6dc883a13dc91ad195305cfdaaec667137ac236562fbed.jpeg",
    "https://cdn.faire.com/fastly/6ba0935ea839aaaef777cbf93be700ffed7e0b60063ff2a461d8564b8ed9fa81.jpeg",
    "https://cdn.faire.com/fastly/e4ebb390048a5d1a08b872806139997c27b19158c75ac06a6a1154e535e2503e.jpeg",
  ],
  priceDollars: 311.78,
  description:
    "* Style No.: WB7116\n\n╴Women's Tailored Taffeta Short Sleeve Button Up Blouse\n╴Crisp taffeta fabric with a structured, elevated feel.\n╴Button-up front for a polished, versatile finish.\n╴Tailored silhouette with subtle seam detailing for clean structure.\n╴Style with high-waisted trousers for office chic or pair with a skirt for an elegant evening look.\n\nFabric: Woven\n100% POLYESTER\nHand Wash Cold\nSizes in Pack:2S-2M-2L",
  tags: [],
  msrpDollars: 623.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:20.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
